import { useLogger } from '~/composables/useLogger';
import { hasOfflineFavorites } from '~/composables/useOfflineFavorites';

/**
 * Syncs shorts favorites saved while logged out.
 * The shorts page watcher is disposed on navigation, so a later login on
 * another route never posted wishlist_property_added.
 *
 * Runs on the logged-out → logged-in edge and also when the page opens
 * already logged in. A WebView reload after OTP often restores the session
 * cookie without emitting that edge.
 */
export default defineNuxtPlugin(nuxtApp => {
	const logger = useLogger('OfflineFavoritesSync');

	function scheduleSync(): void {
		if (!hasOfflineFavorites()) return;

		void import('~/composables/syncOfflineFavorites')
			.then(m => nuxtApp.runWithContext(() => m.syncOfflineFavorites()))
			.catch((error: unknown) => {
				logger.error('syncOfflineFavorites failed', {
					operation: 'syncOfflineFavorites',
					error
				});
			});
	}

	nuxtApp.hook('app:suspense:resolve', () => {
		const { loggedIn } = useUserSession();

		if (loggedIn.value) scheduleSync();

		watch(loggedIn, (isLoggedIn, wasLoggedIn) => {
			if (!isLoggedIn || wasLoggedIn) return;
			scheduleSync();
		});
	});
});
